import { action, observable } from 'mobx';
import { BaseStore } from '~web/store/base/base-store';

export class PaymentSectionFlowStore extends BaseStore {
  @observable isPaymentMeansOverlayOpened: boolean;
  @observable isCreatePaymentMeansOverlayOpened: boolean;

  constructor() {
    super();
    this.clear();
  }

  @action
  openPaymentMeansOverlay(): void {
    this.isPaymentMeansOverlayOpened = true;
  }

  @action
  closePaymentMeansOverlay(): void {
    this.isPaymentMeansOverlayOpened = false;
  }

  @action
  openCreatePaymentMeansOverlay(): void {
    this.isCreatePaymentMeansOverlayOpened = true;
  }

  @action
  closeCreatePaymentMeansOverlay(): void {
    this.isCreatePaymentMeansOverlayOpened = false;
  }

  @action
  clear(): void {
    this.isPaymentMeansOverlayOpened = false;
    this.isCreatePaymentMeansOverlayOpened = false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/store/transaction/payment-section-flow-store.ts